import { Column } from "@tanstack/react-table";
import styles from "../base/cells/TableCells.module.scss";

/**
 * Get the common classes for adding shadow styles to pinned columns
 */
export const getCommonPinningClasses = <T>(
  column: Column<T>,
): string | undefined => {
  const isPinned = column.getIsPinned();
  const isLastLeftPinnedColumn =
    isPinned === "left" && column.getIsLastColumn("left");
  const isFirstRightPinnedColumn =
    isPinned === "right" && column.getIsFirstColumn("right");

  if (isLastLeftPinnedColumn) {
    return styles["last-pinned-left-column"];
  }
  if (isFirstRightPinnedColumn) {
    return styles["first-pinned-right-column"];
  }
};
